import moment from "moment";
import _ from 'lodash';

const removeDetectKeywordFromVisuals = (tracker) => {
    if (tracker?.includes("-detect")) {
        return tracker.replace("-detect", "");
    }
    if (tracker?.includes("detect")) {
        return tracker.replace("detect", "");
    }
    return tracker;
}

const descendingComparator = (a, b, orderBy) => {
    // if no orderBy
    if (!orderBy) {
        // string sort
        if (typeof b === 'string' && typeof a === 'string') {
            const lowerB = b.toLowerCase();
            const lowerA = a.toLowerCase();
            if (lowerB < lowerA) {
                return 1;
            }
            if (lowerB > lowerA) {
                return -1;
            }
            return 0;
        } else {
            if (b < a) {
                return -1;
            }
            if (b > a) {
                return 1;
            }
            return 0;
        }
    }

    // boolean sort
    if (typeof b[orderBy] === 'boolean' || typeof a[orderBy] === 'boolean') {
        return a[orderBy] - b[orderBy]; // `true` (1) comes before `false` (0) in descending order
    }
    // array sort
    if (Array.isArray(a[orderBy])) {
        if (b[orderBy].length < a[orderBy].length) {
            return -1;
        }
        if (b[orderBy].length > a[orderBy].length) {
            return 1;
        }
        return 0;
    }
    // date sort
    if (moment(a[orderBy]).isValid() && ["created", "startdate", "createdAt"].includes(orderBy)) {
        if (moment(b[orderBy]).isBefore(moment(a[orderBy]))) {
            return -1;
        }
        if (moment(b[orderBy]).isAfter(moment(a[orderBy]))) {
            return 1;
        }
        return 0;
    }
    // string sort
    if (typeof b[orderBy] === 'string' && typeof a[orderBy] === 'string') {
        const lowerB = b[orderBy].toLowerCase();
        const lowerA = a[orderBy].toLowerCase();
        if (lowerB > lowerA) {
            return -1;
        }
        if (lowerB < lowerA) {
            return 1;
        }
        return 0;
    }
    // general sort
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparatorSort = (order, orderBy) => {
    return order === 'asc' // Corrected to 'asc'
        ? (a, b) => descendingComparator(b, a, orderBy) // Corrected the order of a and b
        : (a, b) => descendingComparator(a, b, orderBy);
};

const getPageInfo = (currentPage) => {
    const pageData = {
        '/': {
            page: 'Analytics'
        },
        '/campaigns': {
            page: 'Campaigns'
        },
        '/campaign': {
            page: 'Campaigns'
        },
        '/conversation': {
            page: 'Conversation'
        },
        '/playlists': {
            page: 'Playlists'
        },
        '/insights': {
            page: 'Insights'
        },
        '/insight-phrases': {
            page: 'Insights'
        },
        '/alerts': {
            page: 'Alerts'
        },
        '/companies': {
            page: 'Settings'
        },
        '/users': {
            page: 'Settings'
        },
        '/insight-admin': {
            page: 'Settings'
        },
        '/organisation': {
            page: 'Manage Users'
        },
        "/edit-company": {
            page: 'Settings'
        },
        '/profile': {
            page: 'Profile'
        },
        '/privacy': {
            page: 'Privacy'
        },
        '/terms': {
            page: 'Terms'
        },
        '/support': {
            page: 'Support'
        }
    }

    return pageData[currentPage];
}

// Getting Formik Schema Required Validation
const isFieldRequired = (schema, controlId) => {
    return schema?.fields[controlId]?.tests?.some((test) => test?.OPTIONS?.name === 'required');
};

const capitalize = (input) => {
    if (typeof input !== 'string' || !input.length) return '';
    return input[0].toUpperCase() + input.slice(1);
}

// Generate UUID for file naming
const create_UUID = () => {
    let dt = new Date().getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        let r = (dt + _.random(0, 15, true)) % 16 | 0; // true = floating-point
        dt = Math.floor(dt / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
};


const getDurationString = (dataSeconds, placeholder = "0") => {
    if (!dataSeconds) {
        return placeholder;
    }
    const duration = moment.duration(dataSeconds, 'seconds');

    const hours = duration.hours();
    const minutes = duration.minutes() + (hours * 60);
    const seconds = duration.seconds();

    return `${minutes} min ${seconds} sec`;
}

const roundNumberHelper = (score, placeholder = 0) => {
    if (!score) {
        return placeholder;
    }
    
    const roundedNumber = _.round(score, 2);
    
    const decimal = roundedNumber % 1; // get decimal part
    
    if (decimal > 0 && decimal < 0.5) {
        return _.floor(roundedNumber);
    } else {
        return _.ceil(roundedNumber);
    }
}

export {
    removeDetectKeywordFromVisuals,
    getComparatorSort,
    getPageInfo,
    isFieldRequired,
    capitalize,
    create_UUID,
    getDurationString,
    roundNumberHelper
}